import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

const OldShopRedirect = props => {
  const { username, tab } = props.match.params;

  let pathname = `/shop/${username}`;
  let search = '';

  if (tab) {
    search = `?Section_title=${tab}&tab=collections`;
  }

  return <Redirect to={{ pathname, search }} />;
};

OldShopRedirect.propTypes = {};

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {})(OldShopRedirect);
